<!-- <h1>{{'PROFILE.MYֹ_ACCOUNT' | translate}}</h1> -->
<div #payments class="paymentPage full-height">
  <div class="row" style="justify-content: center;">
    <button class="routing-btn"
      [ngClass]="{'currentTab':showAccountSettings===true ,'otherTab':showAccountSettings===false}"
      (click)="showAccountSettings=true">{{'PROFILE.ACCOUNT_SETTINGS' | translate}}</button>
    <button class="routing-btn"
      [ngClass]="{'currentTab':showAccountSettings===false ,'otherTab':showAccountSettings===true}"
      (click)="showAccountSettings=false">{{'PROFILE.PAYMENTS' | translate}}</button>
   
  </div>
   <div class="content-payment">
      <app-profile-details *ngIf="showAccountSettings"></app-profile-details>
      <app-profile-payments *ngIf="!showAccountSettings&&AppResolutionType == ResolutionType.Desktop"></app-profile-payments>
      <app-payments-mobile *ngIf="!showAccountSettings&&AppResolutionType == ResolutionType.Mobile"></app-payments-mobile>
    </div>
</div>
